import React, { Component } from 'react'
import axios from 'axios';
import StructQuestion from './StructQuestion.js'
import FormProspecto from './FormProspecto'
import '../../CSS/feedback.css';
import spinner from '../../images/loading-spinner.gif';

let cancelToken;
let objQuestion = {}
let objCategory = {}

class QuestionsContainer extends Component{
    constructor(props) {
        super(props);
        this.state = {
            pollId: 0,
            centro_id: '',
            errorPoll: '',
            message: '',
            pollComplete: false,
            disabled: true,
            sendPost: false,
            objPreguntas: {},
            objAnswers: {}
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        this.setState({centro_id: this.props.info.centro_id, pollId: this.props.info.pollId});
        this.getPreguntasCategoria()
    }

    getPreguntasCategoria = () => {
        let params = {token_id: this.props.getTokenId, centro_id: this.props.info.centro_id}
        this.props.post(
            "/improvement/getEncuesta", params, (response) => this.handleSuccesPreguntas(response), (error) => this.handleErrorPreguntas(error), cancelToken
        );
    }

    handleSuccesPreguntas = (response) => {
        this.setState({objPreguntas: response})
        // Si existe la encuesta se crea objeto para alamcenar respuestas
        if (Object.keys(response.encuesta).length > 0) {
            Object.values(response.encuesta).map((categoria) => {
                objQuestion = {}
                Object.values(categoria.pregunta).map((pregunta) => {
                    const objResponse = {'coment': '', 'calif': '', 'tipo': pregunta.tipo}
                    objQuestion[pregunta.id] = objResponse
                    objCategory[pregunta.categoria_id] = objQuestion
                })
            })   
        }
    }

    handleErrorPreguntas = (codeError, param_uno, param_dos, msgError) => { this.setState({objPreguntas: {}}) }

    handleInputChangeRadio = (event) =>{
        let id = event.target.getAttribute('question')
        let categoria_id = event.target.getAttribute('categoria')
        let value = event.target.value
        // al usuario calificar una pregunta sobreescribe el valor inicial
        objCategory[categoria_id][id]['calif'] = value
        this.setState({objAnswers: objCategory, disabled: false, message: ''})
    }

    handleInputChangeComent = (event) => {
        let id = event.target.getAttribute('question')
        let categoria_id = event.target.getAttribute('categoria')
        let value = event.target.value
        // al usuario cometar una pregunta sobreescribe el valor inicial
        objCategory[categoria_id][id]['coment'] = value
        this.setState({objAnswers: objCategory, disabled: false, message: ''})
    }

    handleSubmitPoll = (event) => {
        event.preventDefault();
        this.setState({sendPost: true, disabled: true})
        let params = {token_id: this.props.getTokenId, pollId: this.state.pollId, centro_id: this.state.centro_id, email: this.props.info.email, objAnswers: this.state.objAnswers}
        if (params.centro_id > 0) {
            this.props.post('/improvement/saveAnswer', params, (response) => this.handleSuccesPoll(response), (error) => this.handleErrorPoll(error), cancelToken )
        }
    }

    
    handleSuccesPoll = (response) => { this.setState({pollComplete: true, sendPost: false}) }

    handleErrorPoll = (codeError, param_uno, param_dos, msgError) => { this.setState({pollComplete: false, errorPoll: 'Error al guardar encuesta.', sendPost: false}) }

    handleClickSave = (event) => {
        let i = 0;
        if (Object.keys(objCategory).length > 0) {
            Object.values(objCategory).map((categoria) => {
                Object.values(categoria).map((pregunta) => {
                    if (pregunta.tipo == 'Opcion' && (pregunta.calif == "" || pregunta.calif === null)){
                        i++;
                    }
                })
            })
            
        }
        if (i > 0) {
            this.setState({disabled: true})   
            this.setState({message: 'Pendiente contestar '+i+' pregunta(s)'})
            return false
        }
    }

    // Formualrio preguntas
    renderQuestion = () => {
        return(
            <StructQuestion
                arrQuestions = {this.state.objPreguntas}
                handleInputChangeRadio = {this.handleInputChangeRadio}
                handleInputChangeComent = {this.handleInputChangeComent}
            />
        )
    }

    // Contenedor para dibujar formualrio de prospecto
    renderProspecto = () => {
        return (
            <FormProspecto
                getTokenId = {this.props.getTokenId}
                info = {this.state}
                post = {this.props.post}
            />
        )
    }

    render () {
        return(
            <div className="panel-body uno">
                <div className = "container-fluid">
                    <div className="panel panel-default">
                        <div className="panel-body text-left">
                            {(!this.state.pollComplete) ? this.contentView() : this.renderProspecto()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    // Reenderiza formulario con preguntas
    contentView() {
        if (Object.values(this.state.objPreguntas).length > 0) {
            return (
                <div>
                    <form id="cuestions" method="post" onSubmit={this.handleSubmitPoll}>
                        <fieldset>
                            <div className="row form_improvement" style={form}>
                                {this.renderQuestion()}
                            </div>
                            <div className="col-xs-12 text-center">
                                {(this.state.message) ? <p style={p}>{this.state.message}</p> : ''}
                                <button className="btn_form_poll" type="submit" onClick={this.handleClickSave}  readOnly={this.state.disabled}> {this.state.sendPost ? 'ENVIANDO...' : 'GUARDAR CAMBIOS'}</button>
                                <img className={this.state.sendPost ? "" : "hidden"} src={spinner} style={{width: '45px', height: '45px'}}/>
                            </div>
                        </fieldset>
                    </form>
                </div>
            )
        } else {
            return (
                <h2 className="subtitle-section">Encuesta no disponible.</h2>
            )
        }
    }
}

export default (QuestionsContainer);
const form = { border: '1px solid #dfdede'}
const p = {color: 'orange', fontSize: 'small', fontWeight: 'bold'}



// WEBPACK FOOTER //
// ./src/guest/improvement/QuestionsContainer.js